import type { WorkspaceFeature } from "@insights/contracts";
import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router";
import { useWorkspaceContext } from "../hooks/useWorkspaceContext";
import { Loading } from "./Loading";

export function WorkspaceFeatureRoute({
  children,
  feature,
}: {
  children: ReactNode;
  feature: WorkspaceFeature;
}) {
  const { workspaceId } = useParams();
  const workspace = useWorkspaceContext(workspaceId);

  if (workspace.isLoading) {
    return <Loading />;
  }
  if (!workspace.data?.features[feature]) {
    return <Navigate to={`/w/${workspaceId}/pulse/activity`} replace />;
  }
  return children;
}
